import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import DocumentMeta from "react-document-meta";
import HeaderBanner from "../Components/HeaderBanner";
import HelpItem from "../Components/HelpItem";
import HelpSearchBox from "../Components/HelpSearchBox";
import Pagination from "../Components/Pagination";
import Loading from "./Loading";
import Config from "../config.json";
import ContextComponent from "../Context";
import Product from "../Images/product.png";
import Statics from "../Statics";
import HelpSidebar from "./HelpSidebar";
import "./helpContainer.css";
import { useParams } from "react-router-dom";

const body = (
  <>
    برای آموزش استفاده و کار با نرم افزار پژوهیار می‌توانید از محتواهای این بخش
    استفاده کنید. برای سایر بخش‌های پژوهیار راهنمای بیشتر و فیلم‌های آموزشی تهیه
    شده است.
  </>
);

const title = "راهنمای آموزش";

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: `${Config.title} | آموزش`,
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const HelpIndex = () => {
  const context = useContext(ContextComponent);
  const { helpCategoryId } = useParams();
  const [helps, setHelps] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchedHelps, setSearchedHelps] = useState([]);
  const [loadingState, setLoadingState] = useState(Statics.NOT_LOADED);
  // eslint-disable-next-line
  const [categoryLoadingState, setCategoryLoadingState] = useState(
    Statics.NOT_LOADED,
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const pageSize = 8;

  const getHelpCategories = () => {
    setCategoryLoadingState(Statics.LOADING);
    const storedCategories = sessionStorage.getItem("categories");

    if (storedCategories) {
      setCategories(JSON.parse(storedCategories));
      setCategoryLoadingState(Statics.LOADED);
    } else {
      context.ApiDriver.getHelpCategories(
        {
          parent_id: 0,
        },
        data => {
          setCategories(data.data);
          sessionStorage.setItem("categories", JSON.stringify(data.data));
          setCategoryLoadingState(Statics.LOADED);
        },
        error => {
          console.log(error);
          setCategoryLoadingState(Statics.CAUSED_ERROR);
        },
      );
    }
  };

  const getAllHelpPosts = () => {
    setLoadingState(Statics.LOADING);
    const storedHelps = sessionStorage.getItem("allHelps");

    if (storedHelps) {
      const parsedHelps = JSON.parse(storedHelps);
      setHelps(parsedHelps);
      setTotalCount(parsedHelps.length);
      setLoadingState(Statics.LOADED);
    } else {
      context.ApiDriver.getHelp(
        {
          page_size: 1000,
        },
        data => {
          setHelps(data.data);
          setTotalCount(data.meta.total);
          sessionStorage.setItem("allHelps", JSON.stringify(data.data));
          setLoadingState(Statics.LOADED);
        },
        error => {
          console.log(error);
          setLoadingState(Statics.CAUSED_ERROR);
        },
      );
    }
  };

  useEffect(() => {
    getAllHelpPosts();
    getHelpCategories();
    // eslint-disable-next-line
  }, []);

  const formatTitle = title =>
    title.replace(/\s+/g, "_").replace(/\u200C/g, "--");

  const targetCategory = helpCategoryId?.replace(/_/g, " ").replace(/--/g, "‌");
  const selectedCategory = categories.find(cat => cat.title === targetCategory);

  useEffect(() => {
    if (selectedCategory) {
      setSelectedCategoryId(selectedCategory.id);
      setSearchedHelps([]);
      setCurrentPage(1);
    }
  }, [selectedCategory]);

  const getDynamicTitle = () => {
    if (selectedCategory) return selectedCategory.title;
    if (context.query_parameters["search_term"]) return "نتایج جستجو";
    return "همه مطالب";
  };

  const currentCategoryTotal = context.query_parameters["search_term"]
    ? searchedHelps.length
    : selectedCategory
    ? selectedCategory.posts.length
    : totalCount;
  const renderHelpItems = items =>
    items
      .slice((currentPage - 1) * pageSize, currentPage * pageSize)
      .map(item => (
        <HelpItem
          key={item.id}
          data={item}
          linkToPost={`/help/${formatTitle(item.title)}`}
        />
      ));
  return (
    <DocumentMeta {...page_meta}>
      <HeaderBanner
        body={body}
        title={title}
        image={Product}
        header_color="#cecbfa"
      />
      <Row
        style={{ background: "#eee" }}
        className="w-100 mx-0 p-5 help-parent">
        <Col md={3} className="py-4 py-md-0">
          <HelpSearchBox helps={helps} setSearchedHelps={setSearchedHelps} />
          <HelpSidebar
            sidebar_title="دسته بندی راهنما"
            data={categories}
            selectedCategoryId={selectedCategoryId}
          />
        </Col>
        <Col md={9} className="py-4 py-md-0 help-container">
          {loadingState === Statics.LOADING ? (
            <div className="loading">
              <Loading />
            </div>
          ) : (
            <div className="help-content">
              <p className="category-items-title">{getDynamicTitle()}</p>
              <hr />
              {loadingState === Statics.NOT_LOADED ? "بارگذاری نشده" : null}
              {loadingState === Statics.CAUSED_ERROR ? (
                <div className="error-parent">
                  <p>ارتباط با سرور با مشکل مواجه شد !</p>
                  <img
                    className="error-img"
                    src="images/errorPic.webp"
                    width="200px"
                    alt="error-png"
                  />
                </div>
              ) : null}
              {selectedCategory
                ? renderHelpItems(selectedCategory.posts)
                : context.query_parameters["search_term"]
                ? renderHelpItems(searchedHelps)
                : renderHelpItems(helps)}
              {loadingState === Statics.LOADED &&
                currentCategoryTotal === 0 && (
                  <Row className="not-found-search">موردی یافت نشد</Row>
                )}
            </div>
          )}
        </Col>
      </Row>
      <div
        className="d-flex justify-content-center mx-0 p-4"
        style={{ background: "#eee" }}>
        {currentCategoryTotal > pageSize && (
          <Pagination
            onPageChange={setCurrentPage}
            currentPage={currentPage}
            totalCount={currentCategoryTotal}
            pageSize={pageSize}
          />
        )}
      </div>
    </DocumentMeta>
  );
};

export default HelpIndex;
